/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetNumberOfGachaRequest } from '../../models/get-number-of-gacha-request';
import { GetNumberOfGachaResponse } from '../../models/get-number-of-gacha-response';

export interface GachaServiceGetNumberOfGacha$Params {
      body: GetNumberOfGachaRequest
}

export function gachaServiceGetNumberOfGacha(http: HttpClient, rootUrl: string, params: GachaServiceGetNumberOfGacha$Params, context?: HttpContext): Observable<StrictHttpResponse<GetNumberOfGachaResponse>> {
  const rb = new RequestBuilder(rootUrl, gachaServiceGetNumberOfGacha.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetNumberOfGachaResponse>;
    })
  );
}

gachaServiceGetNumberOfGacha.PATH = '/api/v3/gateway/gacha/copies';
